// store
import useCommonStore from 'store/useCommonStore';
// hooks
import usePageScroll from 'hooks/usePageScroll';
import useGetStickyState from 'hooks/search/useGetStickyState';
// components
import MatchFilterRow from 'components/match/MatchFilterRow';
import MatchSelectPlatform from 'components/match/MatchSelectPlatform';
import MatchExcelDownload from 'components/match/MatchExcelDownload';
import TableHeader from 'components/TableHeader';
import MatchResultCount from 'components/match/MatchResultCount';
import MatchTable from 'components/match/MatchTable';
// styles
import style from 'styles/styled-components/style';
import {
	Background,
	BackgroundWrapper,
	StickySectionHeaderRow,
} from 'styles/styled-components/section';
import { useEffect } from 'react';

const Match = () => {
	const { is_scroll, setIsScroll, setCommonFilter } = useCommonStore();

	const bg_ref = usePageScroll();
	const [is_sticky, headerRowRef] = useGetStickyState(bg_ref.current);

	useEffect(() => {
		setCommonFilter('order_by', 'random');
		setCommonFilter('order', 'desc');
	}, []);

	return (
		<BackgroundWrapper>
			<Background
				ref={bg_ref}
				onScroll={() => {
					if (!is_scroll) setIsScroll(true);
				}}
			>
				<StickySectionHeaderRow
					ref={headerRowRef}
					_padding={'32px 16px 16px'}
					radius={is_sticky ? '0' : '16px 16px 0 0'}
					sticky_top="-16px"
				>
					<style.Grid flex="between">
						<MatchSelectPlatform />
						<MatchExcelDownload />
					</style.Grid>
				</StickySectionHeaderRow>

				<MatchFilterRow />
				<TableHeader sticky_top="187px" />

				<MatchResultCount />
				<MatchTable />
			</Background>
		</BackgroundWrapper>
	);
};

export default Match;
